import {StyleSx} from 'app/types/common';

export const containerStyles: StyleSx = {width: 1032, pl: 3, pr: 1.5, my: 2};
